import { useMemo } from 'react';

import ActionCell from '../../../../components/DataTableComponent/components/ActionCell';

export const useProductTableColumns: any = (
  handleDeleteProduct: (id: string) => void,
  handleEditProduct: (id: string) => void
) => {
  return useMemo(
    () => [
      {
        accessorKey: 'image',
        header: 'Image',
        cell: ({ getValue }: any) => (
          <img src={getValue()} alt="product" className="w-12 h-12" />
        )
      },
      {
        accessorKey: 'displayName',
        header: 'Name',
        cell: ({ getValue }: any) => getValue()
      },
      {
        accessorKey: 'quantity',
        header: 'Amount',
        cell: ({ getValue }: any) => getValue()
      },
      {
        accessorKey: 'actions',
        header: null,
        cell: ({ row }: any) => (
          <ActionCell
            rowData={row.original}
            actions={[
              {
                label: 'Edit',
                handler: () => handleEditProduct(row.original.id)
              },
              {
                label: 'Delete',
                handler: () => handleDeleteProduct(row.original.id)
              }
            ]}
          />
        )
      }
    ],
    [handleEditProduct, handleDeleteProduct]
  );
};
